import type { MetaData } from "../types";

export const computeNextMetaData = ({
    current,
    newVisibleIds,
    othersColor,
}: {
    current: MetaData;
    newVisibleIds: Set<string>;
    othersColor: string;
}): MetaData => {
    const availableColors = [...current.availableColors];
    const colorsMap = { ...current.colorsMap };

    current.visibleIds.forEach((id) => {
        if (!newVisibleIds.has(id)) {
            const color = colorsMap[id];
            if (color) {
                availableColors.unshift(color);
                colorsMap[id] = undefined;
            }
        }
    });

    newVisibleIds.forEach((id) => {
        if (!current.visibleIds.has(id)) {
            colorsMap[id] = availableColors.shift() ?? othersColor;
        }
    });

    return { availableColors, colorsMap, visibleIds: newVisibleIds };
};
